import Text from '@components/Text';
import colors from '@constants/colors';
import { ReactNode } from 'react';

import styles from './styles.module.scss';

interface Props {
    children?: ReactNode;
}

function Badge({ children }:Props) {
    return (
        <div aria-label='badge'
            className={styles.wrapper} >
            <Text className={styles.text}
                fontWeight='medium'
                color={colors.gray6}>
                {children}
            </Text>
        </div>
    );
}

export default Badge;
